<template>
  <div
    v-if="usingIE"
    class="browser-notification"
  >
    <v-row>
      <v-col
        :size="12"
        class="browser-notification__content flex justify-center items-center py-10 bg-orange text-white"
      >
        <h3 class="mx-6 text-center">
          <v-icon icon="exclamation-triangle" />
          We see you are currently using an outdated browser (Internet Explorer). Please use <a
            href="https://www.google.com/chrome/"
            target="_blank"
          >Google Chrome</a> instead.
          <v-icon icon="exclamation-triangle" />
        </h3>
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss">
  .browser-notification {
    width: 100%;

    a {
      color: white;
      text-decoration: underline;
    }
  }
</style>

<script>
import Browser from '@/utils/browser';
export default {
  name: 'VBrowserNotification',
  computed: {
    usingIE() {
      return Browser.isIE();
    },
    browserName() {
      return Browser.getBrowser();
    },
  },
};
</script>
